import { FetchData } from "services/api";

export const fetchSubcontractors = (params = {}, signal) => {
  const searchParams = new URLSearchParams();
  if (params.limit) searchParams.set("limit", params.limit);
  if (params.offset !== undefined) searchParams.set("offset", params.offset);
  if (params.status && params.status !== "All") {
    searchParams.set("status", params.status);
  }
  if (params.search && params.search.trim() !== "") {
    searchParams.set("search", params.search.trim());
  }
  if (params.sortField) {
    searchParams.set("sortField", params.sortField);
  }
  if (params.sortDirection) {
    searchParams.set("sortDirection", params.sortDirection);
  }
  const query = searchParams.toString();
  return FetchData(`/api/sous-traitant${query ? `?${query}` : ""}`, {
    method: "GET",
    signal,
  });
};

export const fetchSubcontractorById = (stId) =>
  FetchData(`/api/sous-traitant/${stId}`, {
    method: "GET",
  });

export const deleteSubcontractorsByIds = (stIds) =>
  FetchData(`/api/sous-traitant/${stIds}`, {
    method: "DELETE",
  });

export const changeSubcontractorsStatusByIds = (stIds) =>
  FetchData(`/api/sous-traitant/status/${stIds}`, {
    method: "PUT",
  });

export const createSubcontractor = (payload) =>
  FetchData("/api/sous-traitant", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateSubcontractor = (stId, payload) =>
  FetchData(`/api/sous-traitant/${stId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
